module.exports = __webpack_public_path__ + "img/flag_and_logo.011c51ea.jpg";